const KNOWLEDGE_BASE_LOCALE_PATHS: Record<string, string> = {
  "en-GB": "en-gb",
  "en-US": "en-gb",
  da: "da",
  de: "de",
  fr: "fr",
  no: "nb-no",
  sv: "sv",
};

export function localizedKnowledgeBaseUrl(url: string, locale: string): string {
  const localePath = KNOWLEDGE_BASE_LOCALE_PATHS[locale] ?? "en-gb";
  return url.replace(/\/hc\/en-gb\//, `/hc/${localePath}/`);
}
